import { HTTP, ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

export const registerBufete = async (data) => {
    const response = await fetchFromLawfeed({
        method: HTTP.POST,
        endpoint: ENDPOINT.registerOrganization,
        body: data
    });

    return response;
}